import { Projects, initialState, viewSelector} from './projects.state';
import { ProjectsActions, ProjectsActionType, UpdateProject } from './projects.actions';

import * as Search from '@app/models/search';
import { ProjectLogbookEventList } from '@app/models/logbook-events.model';
import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';

import * as projectUtils from './projects.utils';
export function projectsReducer(state = initialState, action: ProjectsActions): Projects {

    switch (action.type) {
		// EVENTS STATUS

        case ProjectsActionType.LoadProjectSuccess:
            return {
                ...state,
                view: { ...state.view, project: action.project, header: null }, // Clear header on full success
                errors: { ...state.errors, load_project: null }
            };

        // Drop the previous project's uploaded versions: the dashboard artworks panel reads them
        // straight from the store and would render them until the new project's ones arrive.
        case ProjectsActionType.LoadWithUploadedVersions:
            return {...state, view: {...state.view, uploaded_versions: null }};
        case ProjectsActionType.LoadWithUploadedVersionsSuccess:
            return {...state, view: {...state.view, project: action.project }, errors: {...state.errors, load_project: null }};
        case ProjectsActionType.LoadWithUploadedVersionsError:
            return {...state, view: {...state.view, project: null }, errors: {...state.errors, load_project: action.error }};
        case ProjectsActionType.LoadPartialProjectSuccess:
            return {
                ...state,
                view: { ...state.view, project: null, header: action.header }, // Set header, clear project
                errors: { ...state.errors, load_header: null, load_project: null } // Clear both errors
            };
        case ProjectsActionType.LoadProjectError:
            return {
                ...state,
                view: { ...state.view, project: null, header: null }, // Clear both on true error
                errors: { ...state.errors, load_project: action.error }
            };
        case ProjectsActionType.LoadProjectFilesSuccess:
            return {...state, view: {...state.view, files: action.files}, errors: {...state.errors, load_project_files: null }};
            // return state;
        
        case ProjectsActionType.LoadProjectFilesError:
            return {...state, view: {...state.view, files: []}, errors: {...state.errors, load_project_files: action.error }};
            // return state;

        case ProjectsActionType.LoadProjectOriginVersionSuccess:
            return {...state, view: {...state.view, origin_version: action.versions.length>0? action.versions[0] : null}, errors: {...state.errors, load_project_origin_version: null }};
            // return state;
        
        case ProjectsActionType.LoadProjectOriginVersionError:
            return {...state, view: {...state.view, origin_version: null}, errors: {...state.errors, load_project_origin_version: action.error }};
            // return state;

        case ProjectsActionType.DeleteOneProjectFile:
            return {
                ...state, 
                view: {
                    ...state.view, 
                    files: state.view.files.map((file: Objects.AmsFile) => file.id == action.file.id? {...file, active: action.active} : file) 
                }, 
                errors: {
                    ...state.errors, 
                    set_active_project_file: null 
                }
            };
            // return state;
        case ProjectsActionType.DeleteOneProjectFileError:
            return {...state, errors: {...state.errors, set_active_project_file: action.error }};
            // return state;

        case ProjectsActionType.UploadProjectFilesSuccess:
            return {...state, view: {...state.view, files: [...state.view.files, ...action.files]}, errors: {...state.errors, upload_project_files: null }};
        
        case ProjectsActionType.UploadProjectFilesError:
            return {...state, errors: {...state.errors, upload_project_files: action.error }};

        case ProjectsActionType.LoadEditorAssignersSuccess:
            return {...state, 
                logbook: {...state.logbook, available_filters: {...state.logbook.available_filters,
                    users: {...state.logbook.available_filters.users, items: action.users }
                    }
                },
                editor: {...state.editor, assigners: action.users}, 
                errors: {...state.errors, load_editor_assigners: null}};
        
        case ProjectsActionType.LoadEditorAssignersError:
            return {...state, errors: {...state.errors, load_editor_assigners: action.error}};
        
        case ProjectsActionType.LoadEditorWorkflowTransitionsSuccess:
            return {...state, editor: {...state.editor, workflow_transitions: action.transitions}, errors: {...state.errors, load_editor_workflow_transitions: null}};
        
        case ProjectsActionType.LoadEditorWorkflowTransitionsError:
            return {...state, errors: {...state.errors, load_editor_workflow_transitions: action.error}};
        
        case ProjectsActionType.SetEditorCurrentWorkflowTransitions:
            return {...state, 
                    editor: {
                        ...state.editor, 
                            current_workflow_transitions: state.editor.workflow_transitions.filter((t: Objects.WorkflowTransition) => t.origin.id == action.status), 
                        }, 
                    errors: {...state.errors, load_editor_current_workflow_transitions: null}};

        case ProjectsActionType.SetEditorCurrentWorkflowTransitionsSuccess:
            return {...state, 
                     errors: {...state.errors, load_editor_current_workflow_transitions: null}};
        
        case ProjectsActionType.SetEditorCurrentWorkflowTransitionsError:
            return {...state, errors: {...state.errors, load_editor_current_workflow_transitions: action.error}};
        
        case ProjectsActionType.LoadEditorAccessSuccess:
            return {...state, editor: {...state.editor, access: action.access}, errors: {...state.errors, load_editor_access: null}};
        
        case ProjectsActionType.LoadEditorAccessError:
            return {...state, errors: {...state.errors, load_editor_access: action.error}};

        case ProjectsActionType.SetProjectAssigned:
            return {...state, view: {...state.view, project: {...state.view.project, user_assigned: action.user}}}
        
        case ProjectsActionType.SetProjectAssignedSuccess:
            return {...state, errors: {...state.errors, set_project_assigned: null}}
        
        case ProjectsActionType.SetProjectAssignedError:
            return {...state, errors: {...state.errors, set_project_assigned: action.error}}

        case ProjectsActionType.SetProjectDue:
            return {...state, view: {...state.view, project: {...state.view.project, due_date: action.date}}}
        
        case ProjectsActionType.SetProjectDueSuccess:
            return {...state, errors: {...state.errors, set_project_due: null}}
        
        case ProjectsActionType.SetProjectDueError:
            return {...state, errors: {...state.errors, set_project_due: action.error}}

        case ProjectsActionType.SetProjectStatus:
            return {...state, 
                editor: {
                    ...state.editor, 
                        current_workflow_transitions: initialState.editor.current_workflow_transitions , 
                    }, 
                view: {...state.view, project: {...state.view.project, status: action.status}}}
        
        case ProjectsActionType.SetProjectStatusSuccess:
            return {...state, errors: {...state.errors, set_project_status: null}}
        
        case ProjectsActionType.SetProjectStatusError:
            return {...state, errors: {...state.errors, set_project_status: action.error}}

        case ProjectsActionType.SetProjectInfo:
            return {...state,
                view: { ...state.view, 
                    project: {...state.view.project, info: action.info }
                }
            }

        case ProjectsActionType.SetProjectInfoSuccess:
            return {...state, errors: {...state.errors, set_project_info: null}}
        
        case ProjectsActionType.SetProjectInfoError:
            return {...state, errors: {...state.errors, set_project_info: action.error}}

        case ProjectsActionType.SetProjectLabels:
            return {
                ...state, view: { ...state.view, project: { ...state.view.project, labels: action.labels } },
                editor: {
                    ...state.editor,
                    actionsStatus: {
                        ...state.editor.actionsStatus,
                        updateLabelsStatus: 1          // In progress
                    }
                }
            }

        case ProjectsActionType.SetProjectLabelsSuccess:
            return {
                ...state, errors: { ...state.errors, set_project_status: null },
                editor: {
                    ...state.editor,
                    actionsStatus: {
                        ...state.editor.actionsStatus,
                        updateLabelsStatus: 2          // DONE
                    }
                }
            }

        case ProjectsActionType.SetProjectLabelsError:
            return {
                ...state, errors: { ...state.errors, set_project_labels: action.error },
                editor: {
                    ...state.editor,
                    actionsStatus: {
                        ...state.editor.actionsStatus,
                        updateLabelsStatus: 3          // Error
                    }
                }
            }

        case ProjectsActionType.LoadProjectMessagesSuccess:
            return { ...state, view: { ...state.view, messages: action.messages.filter( message => !('active' in message) || message.active )}, errors: {...state.errors, load_project_messages: null }};

        case ProjectsActionType.LoadProjectMessagesError:
            return {...state, view: {...state.view, messages: []}, errors: {...state.errors, load_project_messages: action.error }};
        
        case ProjectsActionType.LoadProjectRelatedVersionsSuccess:
            const relatedItems: Objects.Version[] = action.related // Assuming payload contains related items

            // Group related items by common labels
            let groupedByLabels: { [key: string]: Objects.RelatedVersions } = {};
     
            action.related.forEach((item: Objects.Version) => {
                // 22/7/2024 <diego@twonas.com> be aware of sort order by string not id number.
                const labelKey = item.labels.map((label: Objects.Label) => label.id).sort().join('-');
                if (!groupedByLabels[labelKey]) {
                    // Create a new group if it doesn't exist
                    groupedByLabels[labelKey] = {
                        id: labelKey, /* use a labelKey id for the group */
                        labels: item.labels,
                        versions: [],
                        total: 0,
                    };
                }

                // Add the item to the group
                groupedByLabels[labelKey] = {
                    ...groupedByLabels[labelKey],
                    versions: [...(groupedByLabels[labelKey]?.versions || []), item],
                  };
                groupedByLabels[labelKey].total = groupedByLabels[labelKey].versions.length;
            });
            // Custom sorting function for related first by number of tags, then items number
            const relatedSort = (a: Objects.RelatedVersions, b: Objects.RelatedVersions): number => {
                // First, compare by the number of labels (ascending)
                if (a.labels.length !== b.labels.length) {
                    return a.labels.length - b.labels.length;
                }
            
                // If the number of labels is the same, compare by total (descending)
                return b.total - a.total;
            };
            
            
            const relatedVersionsValues: Objects.RelatedVersions[] = Object.values(groupedByLabels);

            // Sort the versionGroups using the customSort function
            const sortedRelatedVersions = relatedVersionsValues.sort(relatedSort);

            return {...state, view: 
                {...state.view,
                    related_versions: sortedRelatedVersions,
                }, 
                errors: {...state.errors, load_project_related_versions: null }
                
            }

                    
        case ProjectsActionType.LoadVersionsFeedbacksSuccess:
            return {...state, view: {
                ...state.view, versions_feedbacks: {
                    ...state.view.versions_feedbacks, 
                    items : [...state.view.versions_feedbacks.items.filter((vf: VersionShareItem) => !action.feedbacks.some((newFeedback: VersionShareItem) => newFeedback.version.id === vf.version.id  && newFeedback.entry.user.id === vf.entry.user.id)), ...action.feedbacks], 
                }
            }}
        case ProjectsActionType.LoadProjectRelatedVersionsError:
            return {...state, errors: {...state.errors, load_project_related_versions: action.error }};
        
        case ProjectsActionType.LoadProjectUploadedVersionsSuccess:
            // switchMap only cancels on a new LoadProjectUploadedVersions, which for the next project is
            // dispatched after its own load succeeds: a previous project's response can land in between.
            if (state.view.project?.id !== action.projectId)
                return state;
            return {...state, view: {...state.view, uploaded_versions: action.versions}, errors: {...state.errors, load_project_uploaded_versions: null }};
    
        case ProjectsActionType.LoadProjectUploadedVersionsError:
            return {...state, errors: {...state.errors, load_project_uploaded_versions: action.error }};

        case ProjectsActionType.LoadProjectFilesNotesCounterSuccess:
            return {...state, view: {...state.view, files_notes_counter: action.notes}, errors: {...state.errors, load_project_files_notes_counter: null }};
        
        case ProjectsActionType.LoadProjectFilesNotesCounterError:
            return {...state, view: {...state.view}, errors: {...state.errors, load_project_files_notes_counter: action.error }};

        // Logbook reducers
        case ProjectsActionType.LoadEventsSuccess:
            const newEvents: Objects.LogbookEvent[] = action.events.map(event => {
                const trackEvent = ProjectLogbookEventList.find((track: Objects.EventTrack) => track.id === event.type);
                return {
                    ...event,
                    title: trackEvent ? trackEvent.title : event.type  // Use event type if no corresponding title found
                };
            });
            if(state.logbook.events == null){
                return {...state, 
                    logbook: {...state.logbook, 
                        events: newEvents,
                        results: {...state.logbook.results,
                            items: newEvents,
                        }
                    }, 
                    errors: {...state.errors, load_events: null }
                };
            } else {
                return { ...state, 
                    logbook: { 
                        ...state.logbook,
                        events: [...state.logbook.events.filter((event: Objects.LogbookEvent) => !newEvents.some((ev: Objects.LogbookEvent) => event.id == ev.id)), ...newEvents],
                        results: {
                            ...state.logbook.results,
                                items: [...state.logbook.results.items.filter((event: Objects.LogbookEvent) => !newEvents.some((ev: Objects.LogbookEvent) => event.id == ev.id)), ...newEvents],
                            }
                    }
                };
            }
        case ProjectsActionType.ApplyLogbookSearchFilter: 
            return {...state, 
                logbook: {...state.logbook,
                    search: {...state.logbook.search, 
                        filters: [...state.logbook.search.filters, action.filter],
                        active: true
                    }
                }
            };

        case ProjectsActionType.RemoveLogbookSearchFilter: 
            const newFilters = state.logbook.search.filters.filter((f: Search.SearchAppliedFilter) => !(f.key == action.filter.key && f.item.id == action.filter.item.id)) ;
            return {...state, 
                logbook: {...state.logbook,
                    search: {...state.logbook.search, 
                        filters: newFilters,
                        active: newFilters.length > 0 || state.logbook.search.term != ''
                    }
                }
            };
	    
        case ProjectsActionType.SetLogbookSearchTerm:
            return {...state,  
                logbook: {...state.logbook,
                    search: {...state.logbook.search, 
                        term: action.term, 
                        active: state.logbook.search.filters.length > 0 || action.term != ''}
                }
            };
        
        case ProjectsActionType.UpdateLogbookResults:
            const searchedResults = state.logbook.search.term != '' ? state.logbook.events.filter((event: Objects.LogbookEvent) => projectUtils.searchInLogbook(event, state.logbook.search.term)) : state.logbook.events;
            const filteredResults = searchedResults.filter((event: Objects.LogbookEvent) => projectUtils.filterInLogbook(event, state.logbook.search.filters))
            return {...state,  
                logbook: {...state.logbook,
                    results: {...state.logbook.results,
                        items: filteredResults,
                        // next_page: 2,
                        // status: status,
                    }
                }
            };
        case ProjectsActionType.ClearLogbookSearch:
            return {...state, 
                logbook: {...state.logbook, search: initialState.logbook.search }
                };

        case ProjectsActionType.LoadEventsError:
            return {...state, errors: {...state.errors, load_events: action.error }};
        
        case ProjectsActionType.SetRelatedVersionStatus:
            let group = state.view.related_versions.filter((group: Objects.RelatedVersions) => group.id == action.groupId)[0];
            let updated = group.versions.map((v: Objects.Version) => v.id === action.version.id ? {...v, status: action.status} : v)

            // return state withe the version in the group after status updated
            return {...state, view: 
                {...state.view, 
                    related_versions: [...state.view.related_versions.map((group: Objects.RelatedVersions) => group.id == action.groupId ? {...group, versions: updated} : group)]
                } 
            };
        // restore previous status in case of error
        case ProjectsActionType.SetRelatedVersionStatusError:
            let groupToRestore = state.view.related_versions.filter((group: Objects.RelatedVersions) => group.id == action.groupId)[0]
            let restored = groupToRestore.versions.map((v: Objects.Version) => v.id === action.version.id ? {...v, status: action.version.status} : v)

            // return state with the previous version version status
            return {...state, view: 
                {...state.view, 
                    related_versions: [...state.view.related_versions.map((group: Objects.RelatedVersions) => group.id == action.groupId ? {...group, versions: restored} : group)]
                } 
            };
        
        case ProjectsActionType.SetUploadedVersionStatus:
            // return state withe the version uploaded status updated
            return {...state, view: 
                {...state.view, 
                    uploaded_versions: [...state.view.uploaded_versions.map((v: Objects.Version) => v.id === action.version.id ? {...v, status: action.status} : v)]
                } 
            };
        // restore previous uploaded version status in case of error
        case ProjectsActionType.SetUploadedVersionStatusError:
            // return state with the previous version uploaded version status
            return {...state, view: 
                {...state.view, 
                    uploaded_versions: [...state.view.uploaded_versions.map((v: Objects.Version) => v.id === action.version.id ? {...v, status: action.version.status} : v)]
                } 
            };
        case ProjectsActionType.Clear:
            return {...state, view: initialState.view, logbook: initialState.logbook, errors: initialState.errors};

        case ProjectsActionType.ClearEditorAccess:
            return {...state, editor: {
                ...state.editor, access: initialState.editor.access}, errors: {...state.errors, load_editor_access: initialState.errors.load_editor_access}};
    
        case ProjectsActionType.ClearEditorTransitions:
            // console.log(" cleaning editor transitions")
            return {...state, editor: {...state.editor, 
                workflow_transitions: initialState.editor.workflow_transitions,
                current_workflow_transitions: initialState.editor.current_workflow_transitions,
            }, errors: initialState.errors};

        case ProjectsActionType.ClearRelatedVersions:
            return {...state, view :{...state.view, related_versions: initialState.view.related_versions}, errors: initialState.errors};
        
	    default:
	        return state;
    }
}
